module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nmodel.config = model.config || {};\nvar additionalClasses = [];\nvar fromButtonAdditionalClasses = [];\nvar toButtonAdditionalClasses = [];\nvar placeholderKeys = {\nfrom: '',\nto: ''\n}\nif(model.config.slim){\nadditionalClasses.push('slim');\nplaceholderKeys.from = 'form.fields.periodAir.placeholder.from';\nplaceholderKeys.to = 'form.fields.periodAir.placeholder.to';\n}\nif(model.dateFrom === null){\nfromButtonAdditionalClasses.push('active');\n}\nif(model.dateTo === null){\ntoButtonAdditionalClasses.push('active');\n}\nif(model.visibilityByFieldCode){\nconst fieldConfig = model.config || {}\nconst separatedFieldCodes = fieldConfig.separatedFieldCodes || {}\nconst fromFieldCode = separatedFieldCodes.from\nif(fromFieldCode && !model.visibilityByFieldCode[fromFieldCode]){\nadditionalClasses.push('fromInvisible')\n}\nconst toFieldCode = separatedFieldCodes.to\nif(toFieldCode && !model.visibilityByFieldCode[toFieldCode]){\nadditionalClasses.push('toInvisible')\n}\n}\nif(model.config.additionalClasses){\nadditionalClasses.push(model.config.additionalClasses)\n}\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<div class=\"from\">\n<button class=\"from <%= fromButtonAdditionalClasses.join(' '); %>\">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-left-stop onLimited\"></i>\n</button>\n<%- include('./air-datetime-picker', { model: { dataDATE: model.dateFrom, fieldCode: \"from\", titleKey: \"form.fields.periodAir.from.title\", placeholderKey: placeholderKeys.from }, config: model.config.from || {}}); %>\n</div>\n<div class=\"center\">\n<div class=\"fromLabel\">von</div>\n<div class=\"toLabel\">bis</div>\n</div>\n<div class=\"to\">\n<%- include('./air-datetime-picker', { model: { dataDATE: model.dateTo, fieldCode: \"to\", titleKey: \"form.fields.periodAir.to.title\", placeholderKey: placeholderKeys.to }, config: model.config.to || {}}); %>\n<button class=\"to <%= toButtonAdditionalClasses.join(' '); %>\">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-right-stop onLimited\"></i>\n</button>\n</div>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/period-air.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
model.config = model.config || {};
var additionalClasses = [];
var fromButtonAdditionalClasses = [];
var toButtonAdditionalClasses = [];
var placeholderKeys = {
from: '',
to: ''
}
if(model.config.slim){
additionalClasses.push('slim');
placeholderKeys.from = 'form.fields.periodAir.placeholder.from';
placeholderKeys.to = 'form.fields.periodAir.placeholder.to';
}
if(model.dateFrom === null){
fromButtonAdditionalClasses.push('active');
}
if(model.dateTo === null){
toButtonAdditionalClasses.push('active');
}
if(model.visibilityByFieldCode){
const fieldConfig = model.config || {}
const separatedFieldCodes = fieldConfig.separatedFieldCodes || {}
const fromFieldCode = separatedFieldCodes.from
if(fromFieldCode && !model.visibilityByFieldCode[fromFieldCode]){
additionalClasses.push('fromInvisible')
}
const toFieldCode = separatedFieldCodes.to
if(toFieldCode && !model.visibilityByFieldCode[toFieldCode]){
additionalClasses.push('toInvisible')
}
}
if(model.config.additionalClasses){
additionalClasses.push(model.config.additionalClasses)
}

    ; __line = 36
    ; __append("\n<div class=\"")
    ; __line = 37
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"from\">\n<button class=\"from ")
    ; __line = 39
    ; __append(escapeFn( fromButtonAdditionalClasses.join(' ') ))
    ; __append("\">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-left-stop onLimited\"></i>\n</button>\n")
    ; __line = 43
    ; __append( include('./air-datetime-picker', { model: { dataDATE: model.dateFrom, fieldCode: "from", titleKey: "form.fields.periodAir.from.title", placeholderKey: placeholderKeys.from }, config: model.config.from || {}}) )
    ; __append("\n</div>\n<div class=\"center\">\n<div class=\"fromLabel\">von</div>\n<div class=\"toLabel\">bis</div>\n</div>\n<div class=\"to\">\n")
    ; __line = 50
    ; __append( include('./air-datetime-picker', { model: { dataDATE: model.dateTo, fieldCode: "to", titleKey: "form.fields.periodAir.to.title", placeholderKey: placeholderKeys.to }, config: model.config.to || {}}) )
    ; __append("\n<button class=\"to ")
    ; __line = 51
    ; __append(escapeFn( toButtonAdditionalClasses.join(' ') ))
    ; __append("\">\n<i class=\"fi fi-infinity onUnlimited\"></i>\n<i class=\"fi fi-arrow-right-stop onLimited\"></i>\n</button>\n</div>\n</div>")
    ; __line = 56
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/period-air.ejs

}